/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_Bank_Placeholder_SituationInputs */

const en_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const de_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const fr_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const es_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const it_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const nl_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const pl_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const fi_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const da_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

const sv_story_bank_placeholder_situation = /** @type {(inputs: Story_Bank_Placeholder_SituationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe the context...`)
};

/**
* | output |
* | --- |
* | "Describe the context..." |
*
* @param {Story_Bank_Placeholder_SituationInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const story_bank_placeholder_situation = /** @type {((inputs?: Story_Bank_Placeholder_SituationInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_Bank_Placeholder_SituationInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_story_bank_placeholder_situation(inputs)
	if (locale === "fr") return fr_story_bank_placeholder_situation(inputs)
	if (locale === "es") return es_story_bank_placeholder_situation(inputs)
	if (locale === "it") return it_story_bank_placeholder_situation(inputs)
	if (locale === "nl") return nl_story_bank_placeholder_situation(inputs)
	if (locale === "pl") return pl_story_bank_placeholder_situation(inputs)
	if (locale === "fi") return fi_story_bank_placeholder_situation(inputs)
	if (locale === "da") return da_story_bank_placeholder_situation(inputs)
	if (locale === "sv") return sv_story_bank_placeholder_situation(inputs)
	return en_story_bank_placeholder_situation(inputs)
});